import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordComponent } from './change-password.component';
import { ChangePasswordService } from '../../service/change-password.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [ChangePasswordComponent],
  exports: [ChangePasswordComponent],
  providers: [ChangePasswordService]
})
export class ChangePasswordModule { }
